import React, { useState } from 'react';

const AdminUserReport = ({ reports, readNotifications, setReadNotifications, onMarkAsRead }) => {
    const [expanded, setExpanded] = useState(null);

    if (!reports || !reports.length) {
        return <div style={{ padding: '10px', color: '#666' }}>No user reports</div>;
    }

    const handleClick = (id) => {
        // 🔹 Persist read state in backend
        if (onMarkAsRead) {
            onMarkAsRead(id);
        }

        // 🔹 Update local state
        setReadNotifications((prev) => new Set(prev).add(id));

        // 🔹 Toggle expanded view
        setExpanded(expanded === id ? null : id);
    };

    return reports.map((report) => {
        const isRead = readNotifications.has(report.notification_id);
        const isExpanded = expanded === report.notification_id;

        return (
            <div
                key={report.notification_id}
                onClick={() => handleClick(report.notification_id)}
                style={{
                    padding: '10px 12px',
                    background: isRead ? '#e0e0e0' : '#f9f9f9',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    cursor: 'pointer',
                    marginBottom: '6px',
                    transition: 'background 0.2s'
                }}
            >
                <div style={{ fontWeight: '500' }}>{report.message}</div>

                {isExpanded && (
                    <div
                        style={{
                            marginTop: '6px',
                            fontSize: '0.85rem',
                            color: '#333',
                            background: '#fff',
                            padding: '6px',
                            border: '1px solid #ddd',
                            borderRadius: '6px'
                        }}
                    >
                        <pre style={{ margin: 0 }}>{JSON.stringify(report.details, null, 2)}</pre>
                    </div>
                )}

                <div style={{ fontSize: '0.75rem', color: '#555', marginTop: '4px' }}>
                    {new Date(report.created_at).toLocaleString()}
                </div>
            </div>
        );
    });
};

export default AdminUserReport;
